var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      staticClass: "sl-modal",
      attrs: {
        "content-css": { minWidth: "30vw" },
        "no-esc-dismiss": true,
        "no-backdrop-dismiss": true
      },
      model: {
        value: _vm.migrateOpen,
        callback: function($$v) {
          _vm.migrateOpen = $$v
        },
        expression: "migrateOpen"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-icon", { attrs: { name: "call_merge" } }),
              _c("q-toolbar-title", [
                _vm._v("\n        Migrate Instructor\n      ")
              ]),
              _c("q-icon", {
                attrs: { name: "clear", disabled: _vm.migratingInstructor },
                nativeOn: {
                  click: function($event) {
                    return _vm.onClose($event)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-padding" },
            [
              _c(
                "q-field",
                { attrs: { helper: _vm.currentInstructorLabel } },
                [
                  _c(
                    "q-input",
                    {
                      attrs: {
                        "float-label": "Instructor",
                        "clear-value": null,
                        clearable: ""
                      },
                      on: {
                        clear: function($event) {
                          _vm.onSelectInstructor()
                        }
                      },
                      model: {
                        value: _vm.instructorFilter,
                        callback: function($$v) {
                          _vm.instructorFilter = $$v
                        },
                        expression: "instructorFilter"
                      }
                    },
                    [
                      _c("q-autocomplete", {
                        attrs: {
                          debounce: 500,
                          "float-label": "Instructor",
                          "max-results": 10
                        },
                        on: {
                          search: _vm.onInstructorAutocomplete,
                          selected: _vm.onSelectInstructor
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "panel text-center" },
                [
                  _c("q-icon", {
                    attrs: { name: "fa fa-warning", size: "30px" }
                  }),
                  _c("b", [_vm._v("Warning")]),
                  _c("p", [
                    _vm._v(
                      "The selected instructor will replace this affiliates instructor."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "All classes will be merged with the existing instructor if one exists."
                    )
                  ]),
                  _c("p", [_c("b", [_vm._v("THIS CANNOT BE UNDONE.")])])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "q-toolbar",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("q-toolbar-title"),
              _c("q-btn", {
                attrs: {
                  outline: "",
                  color: "faded",
                  disabled: _vm.migratingInstructor,
                  label: "Cancel"
                },
                nativeOn: {
                  click: function($event) {
                    return _vm.onClose($event)
                  }
                }
              }),
              _vm._v("   \n      "),
              _c("q-btn", {
                attrs: {
                  outline: "",
                  color: "primary",
                  loading: _vm.migratingInstructor,
                  disabled: _vm.migratingInstructor,
                  label: "Migrate"
                },
                nativeOn: {
                  click: function($event) {
                    return _vm.onMigrate($event)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-inner-loading",
        { attrs: { visible: _vm.migratingInstructor } },
        [
          _c("q-spinner-gears", { attrs: { color: "primary", size: "70" } }),
          _c("span", [_vm._v("Migrating")])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }